import { render, staticRenderFns } from "./HeroSliderItem.vue?vue&type=template&id=da1b8c00&scoped=true&"
import script from "./HeroSliderItem.vue?vue&type=script&lang=js&"
export * from "./HeroSliderItem.vue?vue&type=script&lang=js&"
import style0 from "./HeroSliderItem.vue?vue&type=style&index=0&id=da1b8c00&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da1b8c00",
  null
  
)

export default component.exports